import type { Theme } from "@mui/material";

export const getCheckedGridSx = (_theme: Theme) => ({
  ".MuiDataGrid-columnHeaders": {
    ".MuiCheckbox-root": {
      display: "none",
      "&.Mui-checked": {
        display: "inherit",
      },
      "&.MuiCheckbox-indeterminate": {
        display: "inherit",
      },
    },
    ":hover .MuiCheckbox-root": {
      display: "inherit",
    },
  },

  ".MuiDataGrid-row": {
    ".MuiDataGrid-cellCheckbox .MuiCheckbox-root": {
      display: "none",
      "&.Mui-checked": {
        display: "inherit",
      },
      "&.MuiCheckbox-indeterminate": {
        display: "inherit",
      },
    },
    ".sharing-action": {
      visibility: "hidden",
    },

    "&:hover, &.Mui-hovered": {
      ".MuiDataGrid-cellCheckbox .MuiCheckbox-root": {
        display: "inherit",
      },
      ".sharing-action": {
        visibility: "visible",
      },
    },
  },
});
